<script>
    import user from "../../stores/user";

    export let warning = null;
    export let page = null;
    export let header = null;
    export let pageIcon = 'warning';

    if (warning === 'no-user') {
        pageIcon = 'user-o';
    } else if (warning === 'no-products') {
        pageIcon = 'shopping-cart';
    }
</script>

{#if header}
    <div class="mb-5">
        <h1>{ header }</h1>
        <div class="heading-separator"></div>
    </div>
{/if}
<div class="page-icon danger mb-5">
    <i class="fa fa-{ pageIcon }"></i>
</div>
<div class="text-center mb-5">
    <!-- user -->
    {#if warning === 'no-user'}
        <p>
            Δεν είστε συνδεμένοι στον λογαριασμό σας.
        </p>
        {#if page === 'checkout'}
            <p>
                Πρέπει να συνδεθείτε με τον λογαριασμό σας στον Π.Κ.Σ. για να μπορέσετε να ολοκληρώσετε την αγορά σας.
            </p>
        {:else if page === 'order-details'}
            <p>
                Πρέπει να συνδεθείτε με τον λογαριασμό σας στον Π.Κ.Σ. για να δείτε τα στοιχεία της παραγγελίας σας.
            </p>
        {/if}
        <p>
            <button href="#" class="btn btn-link fw-bold" on:click={ () => $user.showLogin = true }>Είσοδος</button>
        </p>
    {/if}

    <!-- cart products -->
    {#if warning === 'no-products'}
        <p>
            Δεν υπάρχουν προϊόντα ή υπηρεσίες στο καλάθι αγορών σας.
        </p>
    {/if}

    <!-- order -->
    {#if warning === 'order-not-found'}
        <p>
            Τα στοιχεία της παραγγελίας σας δεν βρέθηκαν.
        </p>
        <p>
            Σιγουρευτείτε πως ο σύνδεσμος είναι σωστός.
        </p>
    {/if}

    <!-- actions -->
    {#if warning === 'action_not_found'}
        <p>
            Το αίτημα δεν βρέθηκε ή το χρονικό όριο του αιτήματος έχει λήξει.
        </p>
    {/if}

    <!-- account -->
    {#if warning === 'account_not_found'}
        <p><strong>Ο λογαριασμός δεν βρέθηκε!</strong></p>
        <p>Για περισσότερες πληροφορίες επικοινωνήστε με την γραμματεία του Π.Κ.Σ.</p>
    {/if}
    {#if warning === 'account_not_active'}
        <p><strong>Ο λογαριασμός σας δεν είναι ενεργός!</strong></p>
        <p>Για περισσότερες πληροφορίες επικοινωνήστε με την γραμματεία του Π.Κ.Σ.</p>
    {/if}
    <!--{#if warning === 'account-not-verified'}-->
    <!--    <p><strong>Μη επαληθευμένος λογαριασμός!</strong></p>-->
    <!--    <p>Ο λογαριασμός σας δεν είναι επαληθευμένος.</p>-->
    <!--{/if}-->
</div>